'use strict';

var skeletonBorderRadiusMapper = {};

exports.__exports = skeletonBorderRadiusMapper;
//# sourceMappingURL=skeletonBorderRadiusMapper.cjs.map
